export default "__VITE_ASSET__DVo0OYcY__"